import { apiCall } from "@/app/api/apiCall";
import { ApiClient } from "./types";

const BASE_URL = `${process.env.REACT_APP_BASE_URL || ""}/api`;

const createHeaders = () => ({
  "Content-Type": "application/json",
});

export const apiClient: ApiClient = {
  createSponsorshipFieldOption: async (field, body) => {
    return apiCall(`${BASE_URL}/fields/sponsorships/${field}/options/`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: createHeaders(),
    });
  },
  createMediaRateFieldOption: async (field, body) => {
    return apiCall(`${BASE_URL}/fields/media-rates/${field}/options/`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: createHeaders(),
    });
  },
  uploadFile: async (file) => {
    const fileName = `${new Date().getTime()}.${file.name.split(".")[1]}`;
    return apiCall(`${BASE_URL}/upload-file/${fileName}/`, {
      method: "POST",
      body: file,
      headers: {
        ...createHeaders(),
        "Content-Type": file.type,
      },
    });
  },
  getToken: async (args) => {
    return apiCall(`${BASE_URL}/auth/token/`, {
      method: "POST",
      body: JSON.stringify(args),
      headers: { "Content-Type": "application/json" },
    });
  },
  logout: async () => {
    return apiCall(`${BASE_URL}/logout/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
  },
  requestPasswordResetTokenEmail: async (args) => {
    return apiCall(`${BASE_URL}/users/reset-password-request/`, {
      method: "POST",
      body: JSON.stringify(args),
      headers: { "Content-Type": "application/json" },
    });
  },
  resetPassword: async (args) => {
    return apiCall(`${BASE_URL}/users/reset-password/`, {
      method: "POST",
      body: JSON.stringify(args),
      headers: { "Content-Type": "application/json" },
    });
  },
  signUp: async (args) => {
    return apiCall(`${BASE_URL}/users/register/`, {
      method: "POST",
      body: JSON.stringify(args),
      headers: { "Content-Type": "application/json" },
    });
  },
  getUserSelf: async () => {
    return apiCall(`${BASE_URL}/users/me/`, {
      headers: createHeaders(),
    });
  },
  getUsers: async (params) => {
    return apiCall(
      `${BASE_URL}/users/${!!params.size ? `?${params.toString()}` : ""}`,
      {
        headers: createHeaders(),
      }
    );
  },
  getUser: async (id) => {
    return apiCall(`${BASE_URL}/users/${id}/`, {
      headers: createHeaders(),
    });
  },
  updateUser: async (body) => {
    return apiCall(`${BASE_URL}/users/${body.id}/`, {
      method: "PUT",
      body: JSON.stringify(body),
      headers: createHeaders(),
    });
  },
  getUserFields: async () => {
    return apiCall(`${BASE_URL}/fields/users/?page_size=1000`, {
      headers: createHeaders(),
    });
  },
  getSponsorships: async (params) => {
    return apiCall(
      `${BASE_URL}/sponsorships/${
        !!params.size ? `?${params.toString()}` : ""
      }`,
      {
        headers: createHeaders(),
      }
    );
  },
  getSponsorship: async (id) => {
    return apiCall(`${BASE_URL}/sponsorships/${id}/`, {
      headers: createHeaders(),
    });
  },
  deleteSponsorship: async (id) => {
    return apiCall(`${BASE_URL}/sponsorships/${id}/`, {
      headers: createHeaders(),
      method: "DELETE",
    });
  },
  createSponsorship: async (body) => {
    return apiCall(`${BASE_URL}/sponsorships/`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: createHeaders(),
    });
  },
  updateSponsorship: async (body) => {
    return apiCall(`${BASE_URL}/sponsorships/${body.id}/`, {
      method: "PUT",
      body: JSON.stringify(body),
      headers: createHeaders(),
    });
  },
  getSponsorshipFields: async () => {
    return apiCall(`${BASE_URL}/fields/sponsorships/?page_size=1000`, {
      headers: createHeaders(),
    });
  },
  getSponsorshipFieldOptions: async (field) => {
    return apiCall(
      `${BASE_URL}/fields/sponsorships/${field}/options/?page_size=1000`,
      {
        headers: createHeaders(),
      }
    );
  },
  getMediaRateFieldOptions: async (field) => {
    return apiCall(
      `${BASE_URL}/fields/media-rates/${field}/options/?page_size=1000`,
      {
        headers: createHeaders(),
      }
    );
  },
  getUserFieldOptions: async (field) => {
    return apiCall(`${BASE_URL}/users/${field}/options/?page_size=1000`, {
      headers: createHeaders(),
    });
  },
  getMediaRates: async (params) => {
    return apiCall(
      `${BASE_URL}/media-rates/${!!params.size ? `?${params.toString()}` : ""}`,
      {
        headers: createHeaders(),
      }
    );
  },
  getMediaRate: async (id) => {
    return apiCall(`${BASE_URL}/media-rates/${id}/`, {
      headers: createHeaders(),
    });
  },
  deleteMediaRate: async (id) => {
    return apiCall(`${BASE_URL}/media-rates/${id}/`, {
      headers: createHeaders(),
      method: "DELETE",
    });
  },
  createMediaRate: async (body) => {
    return apiCall(`${BASE_URL}/media-rates/`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: createHeaders(),
    });
  },
  updateMediaRate: async (body) => {
    return apiCall(`${BASE_URL}/media-rates/${body.id}/`, {
      method: "PUT",
      body: JSON.stringify(body),
      headers: createHeaders(),
    });
  },
  getMediaRatesFields: async () => {
    return apiCall(`${BASE_URL}/fields/media-rates/?page_size=1000`, {
      headers: createHeaders(),
    });
  },
};
